// test2145
(2145 && 0);
